module.exports = __webpack_public_path__ + "static/img/defaulheadimg.05186c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/trialCenter/defaulheadimg.png
// module id = /s4h
// module chunks = 113